"use client";



import { Body, Heading } from "@/client/foundations/Typography";
import { renderToString } from "react-dom/server";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { ColumnTextScrollable } from "@/blocks/Editorials/ColumnTextScrollable/ColumnTextScrollable";
import React, { useEffect, useState } from "react";
// import { Box } from "@fastlooptech/layout-components";
import { useResponsive } from "@/client/hooks/useResponsive";
import { Box } from "@/layouts/LayoutComponents";
import ImageWrapper from "@/components/ImageWrapper";

export default function ScrollableContainer(props: {id: string, title: string, description: any, image: string, animated: boolean, animationType: string, children: any}) {
  const { id, title, description, image, animated, animationType } = props;
  const [scrollY, setScrollY] = useState(0);
  const { isSm } = useResponsive();

  useEffect(() => {
    window?.addEventListener("scroll", function () {
      setScrollY(window.scrollY);
    });
    return () => window?.removeEventListener("scroll", function () {
      setScrollY(window.scrollY);
    });
  }, []);

  const imageDef = {
    width: 400,
    height: 400,
    src: image ? (image + '?fit=fill&f=center') : "https://placehold.co/400x400",
  };

  return (
    <Box className={isSm ? "" : "overflow-x-hidden"} id={id}>
      <ColumnTextScrollable
        animated={animated}
        animation={animationType}
        className={""}
        leftColumn={
          <>
            {image && (
              <ImageWrapper
                alt="badge-logo"
                src={imageDef?.src}
                placeholder="blur"
                blurDataURL={imageDef.src}
                width={imageDef.width}
                height={imageDef.height}
                objectFit="contain"
                priority
                // loading="lazy"
                style={{
                  transform: `rotate(${scrollY * 0.1}deg)`,
                  transition: "transform 0.1s linear",
                }}
                loader={({ src }) => src}
              />
            )}
            <Heading size={"l"}>{title}</Heading>
            <Body size={"l"}>{description}</Body>
          </>
        }
        rightColumn={props.children}
      />
    </Box>
  );
}